






	// @ts-ignore
    import _ from './CConfirm.ts'; export default _;
